import { Button, ButtonGroup, H5, Slider } from "@blueprintjs/core";
import React from "react";
import styled from "styled-components";

import autobind from "autobind-decorator";
import CheckBoxWidget from "common/form/widgets/CheckBoxWidget";
import { FlexJustify } from "common/fragments/Flex";
import { Padding, WowIcon } from "./styled/fragments";

// tslint:disable:max-classes-per-file

export class EditorConfig {
	public alpha: number = 0.85;
	public sidebarPosition: boolean = false; // vertical
	public sidebarSize: number = 400;
	public leftSize: number = 300;
	public rightSize: number = 300;
	public highlightActive: boolean;
	public minLayoutTreeDepth?: number;
	public theme: "dark" | "doge";
}

export interface IEditorConfigFormProps {
	config: EditorConfig;
	onChange: (config: EditorConfig) => void;
}

const Separator = styled.div`
	margin-top: 15px;
	margin-bottom: 10px;
	font-size: 14px;
	font-weight: bold;
	line-height: 1.5em;
`;

export default class EditorConfigForm extends React.Component<IEditorConfigFormProps> {

	@autobind
	private onChange(prop: object) {
		this.props.onChange({...this.props.config, ...prop});
	}

	public render() {
		const { config } = this.props;

		return (
			<div>
				<Separator>Highlight Active Panel</Separator>

				<CheckBoxWidget onChange={(v: boolean) => this.onChange({highlightActive: v})} value={config.highlightActive} />

				<Separator>Theme</Separator>

				<ButtonGroup>
					<Button disabled={config.theme === "dark"} onClick={() => this.onChange({theme: "dark"})}>Dark</Button>
					<Button disabled={config.theme === "doge"} onClick={() => this.onChange({theme: "doge"})}>
						<WowIcon/>
					</Button>
				</ButtonGroup>

				<Separator>Left Sidebar Size</Separator>

				<Slider
					min={100}
					max={700}
					stepSize={10}
					onRelease={(value) => this.onChange({leftSize: value})}
					onChange={(value) => this.onChange({leftSize: value})}
					labelStepSize={150}
					value={this.props.config.leftSize || 300}
				/>

				<Separator>Right Sidebar Size</Separator>

				<Slider
					min={100}
					max={700}
					stepSize={10}
					onRelease={(value) => this.onChange({rightSize: value})}
					onChange={(value) => this.onChange({rightSize: value})}
					labelStepSize={150}
					value={this.props.config.rightSize || 300}
				/>

				<Separator>Opacity</Separator>

				<Slider
					min={0.50}
					max={1}
					stepSize={0.01}
					onRelease={(value) => this.onChange({alpha: value})}
					onChange={(value) => this.onChange({alpha: value})}
					labelStepSize={0.20}
					value={this.props.config.alpha || 1}
				/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/core/components/editor/EditorConfigForm.tsx